var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextbox3A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 19,
    viewBox: "0 0 67 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5.49219C0.5 4.66376 1.17157 3.99219 2 3.99219H65C65.8284 3.99219 66.5 4.66376 66.5 5.49219V16.4922C66.5 17.3206 65.8284 17.9922 65 17.9922H2C1.17157 17.9922 0.5 17.3206 0.5 16.4922V5.49219Z",
    fill: "white",
    stroke: "#ACACAC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 30,
    height: 8,
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextbox3A);
export default __webpack_public_path__ + "static/media/Textbox3A.69576d9643c989c5b38a6c88d204016d.svg";
export { ForwardRef as ReactComponent };